import { getNotices } from '@/integrations/sanity/api/notices';
import { getPrivacyPolicy } from '@/integrations/sanity/api/privacyPolicy';
import { getSekki } from '@/integrations/sanity/api/sekki';
import { getTermsAndConditions } from '@/integrations/sanity/api/termsAndConditions';

export const cmsApi = {
  getNotices,
  getPrivacyPolicy,
  getSekki,
  getTermsAndConditions,
};
